module.exports = __webpack_public_path__ + "static/cover-project-b751a6526267e2e0ffe3018f69da2181.png";